import React from 'react';
import styles from './Loader.module.scss';

const Loader = ({size = 48, variant = 'light'}) => {
    return <span className={`${styles.loader} ${styles[variant]}`} style={{ width: size, height: size}} />
}

export default Loader;